import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import './Footer.css'

const Footer = () => {
  const location = useLocation();

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-links">
          <Link to={`/termeni${location.search}`} className="footer-link">Termeni și Condiții</Link>
          <Link to={`/gdpr${location.search}`} className="footer-link">GDPR</Link>
          <Link to={`/confidentialitate${location.search}`} className="footer-link">Politica de Confidențialitate</Link>
        </div>
        <p className="footer-copyright">
          © {new Date().getFullYear()} Sustin.ro. Toate drepturile rezervate.
        </p>
      </div>
    </footer>
  )
}

export default Footer 